export default "__VITE_ASSET__Dsi4CKq1__"